import styled from "styled-components";
import { FlexRowDiv, FlexColumn } from "../common.styles";
import { HXMobilePageWithFixedHeaderAndFooterContainer, HXMobilePageWithFixedHeaderAndFooterContent } from "../HXMobilePage.styles";
import { colors } from "healthex-common/colors";
export const AddPatientDataOriginatorMethodParent = styled(HXMobilePageWithFixedHeaderAndFooterContainer).attrs({
    overflowYHidden: false,
}) `
    gap: 16px;
    min-width: 680px;
    height: auto;
`;
export const AddPatientDataOriginatorMethodContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({
    isHeaderAndFooterFixed: true,
}) `
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
`;
export const AddPatientDataOriginatorMethodTabs = styled(FlexRowDiv) `
    gap: 0;
    background-color: ${colors.navy_4};
    border: 1px solid ${colors.black_12};
    border-radius: 4px;

    button {
        flex: 1;
        border-radius: 4px;
        border: 1px solid ${colors.black_12};
        color: ${colors.black_main};

        &.MuiButton-contained {
            background-color: ${colors.white_main};
        }

        &.MuiButton-outlined {
            background-color: transparent;
            border: none;
        }
    }
`;
export const AddPatientDataOriginatorMethodTabContent = styled(FlexColumn) `
    gap: 16px;
    margin-top: 16px;
`;
export const AddPatientDataOriginatorMethodFooterContainer = styled(FlexRowDiv) `
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
    align-self: stretch;
    padding: 8px 0;
`;
export const MultilineMRNContainer = styled.div `
    width: 100%;

    .MuiAutocomplete-inputRoot {
        flex-wrap: wrap;
        align-content: flex-start;
    }

    .MuiInputBase-root {
        align-items: flex-start;
        padding-top: 12px;
    }
`;
